import { createActionWithCallbacks } from '@move-frontend/auth';
import { signIn } from '../../domain/use-cases/signIn';

export const signInWithCallbacks = createActionWithCallbacks(signIn);
